import RetencionUpdate from './RetencionUpdate'
export {RetencionUpdate}
export default RetencionUpdate
